module.exports = require("@mario-kart/domain").CourseGen;
